import { IQuiz } from '../IQuiz'

export const ispIntro1: IQuiz = {
  name: 'isp-intro-1',
  question: 'В чём заключается суть принципа разделения интерфейса?',
  variants: [
    {
      text: 'Проектировать интерфейсы так, чтобы получались атомарные, описывающие 1–2 метода интерфейсы',
      description:
        'Основная цель принципа — освободить клиентов от реализации методов, которые им не нужны. Для этого зачастую требуется дробить интерфейсы, но это не самоцель, а только инструмент'
    },
    {
      text:
        'Проектировать интерфейсы так, чтобы реализующие их сущности не зависели от методов, которые они не используют'
    },
    {
      text: 'Проектировать интерфейсы так, чтобы реализующие их сущности не менялись при изменении этих интерфейсов',
      description:
        'Интерфейс описывает поведение сущности. Если требования изменились так, что поменялся интерфейс, значит сущности придётся измениться тоже'
    }
  ],
  meta: {
    correctAnswers: [1]
  }
}
